import { FormEvent, Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IconClient } from "../../assets/svgs-index";
import PoweredBy from "../../components/PoweredBy/PoweredBy";
import PasswordField from "../../components/input/PasswordField";
import ModalInformation from "../../components/Modals/ModalInformation";
import { AuthenticationService } from "../../core/services/authentication.service";


const PasswordUpdate: React.FC<any> = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const email = new URLSearchParams(window.location.search).get('email') || '';
  const [password, setPassword] = useState<string>("");
  const [checkPassword, setCheckPassword] = useState<string>("");

  const [modalInfoIsOpen, setModalInfoIsOpen] = useState<boolean>(false);
  const [modalInfoMessage, setModalInfoMessage] = useState<string>("");
  const [modalInfoSubMessage, setModalInfoSubMessage] = useState<string>("");
  const [modalInfoTitle, setModalInfoTitle] = useState<string>("");
  const [modalInfoConfirmText, setModalInfoConfirmText] = useState<string>("");
  const [modalInfoOnConfirm, setModalInfoOnConfirm] = useState<() => void>();

  const handleChangePassword = (value: string) => {
    setPassword(value);
  };
  const handleChangeCheckPassword = (value: string) => {
    setCheckPassword(value);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (checkPasswordValidation(password, checkPassword)) {
      const body = { password };
      if (token) {
        AuthenticationService.passwordUpdate(body, token).then(res => {
          if (res) {
            setModalInfoTitle(res.title);
            setModalInfoMessage(res.message || "");
            setModalInfoSubMessage(res.subMessage || "");
            setModalInfoConfirmText(res.confirmText);
            res.onConfirm === "onLogin" && setModalInfoOnConfirm(() => goToLogin);
            res.onConfirm === "goToRecoverPassword" && setModalInfoOnConfirm(() => goToRecoverPassword);
            setModalInfoIsOpen(true);
          }
        });
      } else {
        renderModalInvalidToken();
      }
    }
  };

  const checkPasswordValidation = (password: string, passwordConfirm: string) => {
    if (password === passwordConfirm) {
      return true;
    }
    setModalInfoTitle("Dados Incorrectos");
    setModalInfoMessage("As passwords inseridas são diferentes");
    setModalInfoSubMessage("");
    setModalInfoConfirmText("Ok");
    setModalInfoOnConfirm(undefined);
    setModalInfoIsOpen(true);
    return false;
  };

  const goToLogin = () => {
    closeModal();
    navigate(`/login`, { state: {email: email}});
  }

  const goToRecoverPassword = () => {
    closeModal();
    navigate("/recuperar-password");
    navigate(`/recuperar-password`, { state: {email: email}});
  }

  const renderModalInvalidToken = () => {
    setModalInfoTitle("Informação Incorreta");
    setModalInfoMessage("O link de recuperação de password não está correto. \nCarregue em continuar para pedir um novo link. \nObrigado.");
    setModalInfoSubMessage("");
    setModalInfoConfirmText("Continuar");
    setModalInfoOnConfirm(() => goToRecoverPassword);
    setModalInfoIsOpen(true);
  };

  const renderModalInformation = (handler: any) => {
    if (!modalInfoIsOpen) {
      return <Fragment />;
    }
    return (
      <ModalInformation
        modalIsOpen={modalInfoIsOpen}
        title={modalInfoTitle}
        message={modalInfoMessage}
        subMessage={modalInfoSubMessage}
        confirmText={modalInfoConfirmText}
        onClose={() => closeModal()}
        onConfirm={handler || closeModal}
      />
    );
  };

  const closeModal = () => {
    setModalInfoIsOpen(false);
    setModalInfoTitle("");
    setModalInfoMessage("");
    setModalInfoSubMessage("");
    setModalInfoConfirmText("");
    setModalInfoOnConfirm(undefined);
  };

  return (
    <div className="main-page-container container pb-4 h-100 mt-4 pt-0 align-center justify-content-start">
      <div className="company-logo-container mt-2 mt-md-4" onClick={() => navigate("/")}>
        <img className="kmclient-logo" src={IconClient} alt="logo" />
      </div>

      <h3 className="text-center w-100 my-4"> Definir nova Password</h3>

      <div className="grey-box-container py-4 px-5 w-100">
        <div className="box-form-container">
          <form onSubmit={handleSubmit}>
            <PasswordField password={password} onChange={handleChangePassword} />
            <PasswordField
              password={checkPassword}
              onChange={handleChangeCheckPassword}
              label={"Confirmar Password"}
            />

            <button
              className="cta-button-primary d-medium w-100 mt-4"
              type="submit"
              value="Submeter"
            >
              Submeter
            </button>
          </form>
        </div>
      </div>

      <div className="powered-by-container mt-4">
        {" "}
        <PoweredBy />
      </div>
      {renderModalInformation(modalInfoOnConfirm)}
    </div>
  );

};
export default PasswordUpdate;